<template>
  <div id="preview" class="premium-dialog-wrapper">
    <v-card class="premium-checkout-card">
      <v-form ref="form1" v-model="valid1" lazy-validation>
        <!-- Premium Blue Gradient Banner -->
        <div class="checkout-banner">
          <div class="floating-bg-shape shape-1"></div>
          <div class="floating-bg-shape shape-2"></div>

          <v-avatar
            color="rgba(255, 255, 255, 0.15)"
            size="64"
            class="mb-3 payment-avatar"
          >
            <v-icon size="36" color="white" class="pulse-icon"
              >mdi-credit-card</v-icon
            >
          </v-avatar>
          <h2 class="banner-title">
            {{ pageDescription || "Add LO Rename Online Payment" }}
          </h2>
          <p class="banner-subtitle">
            Record and verify online payment details securely
          </p>
        </div>

        <v-card-text class="px-6 py-6 card-content-area">
          <v-container class="pa-0">
            <v-row>
              <!-- Payment Gateway Choice -->
              <v-col cols="12" sm="6" md="6" class="py-2">
                <div class="input-label-wrapper">
                  <v-icon small color="#1565C0" class="mr-1">mdi-bank</v-icon>
                  <label class="premium-label"
                    >Payment Gateway <span class="required-star">*</span></label
                  >
                </div>
                <v-select
                  :reduce="(option) => option.value"
                  :items="PaymentGatewayOptions"
                  :rules="PaymentGatewayRules"
                  v-model="PaymentGateway"
                  required
                  outlined
                  rounded
                  dense
                  class="premium-input"
                  background-color="rgba(21, 101, 192, 0.03)"
                ></v-select>
              </v-col>

              <!-- Payment ID Input -->
              <v-col cols="12" sm="6" md="6" class="py-2">
                <div class="input-label-wrapper">
                  <v-icon small color="#1565C0" class="mr-1"
                    >mdi-key-variant</v-icon
                  >
                  <label class="premium-label"
                    >Payment ID <span class="required-star">*</span></label
                  >
                </div>
                <v-text-field
                  v-model="PaymentId"
                  :rules="PaymentIdRules"
                  placeholder="pay_XXXXXXXXXXXXXX"
                  hint="Enter Razorpay payment ID"
                  persistent-hint
                  required
                  dense
                  outlined
                  rounded
                  class="premium-input"
                  background-color="rgba(21, 101, 192, 0.03)"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <!-- Secure payment warning/indicator -->
        <div
          class="security-badge d-flex align-center justify-content-center py-2 px-6"
        >
          <v-icon x-small color="#4caf50" class="mr-1">mdi-shield-check</v-icon>
          <span>SSL Secured & Encrypted Payment Verification</span>
        </div>

        <!-- Styled Action Footer -->
        <v-card-actions class="px-6 pb-6 pt-2">
          <v-spacer></v-spacer>
          <v-btn
            @click="closePrompt"
            outlined
            rounded
            large
            class="premium-btn btn-close px-6 mr-3"
          >
            Cancel
          </v-btn>
          <v-btn
            :disabled="!valid1"
            @click.prevent="confirmAlert"
            :loading="SubmitFlag"
            large
            rounded
            class="premium-btn btn-save px-8 white--text"
          >
            <v-icon left>mdi-check-circle-outline</v-icon>
            Save Payment
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,

      rows: [],

      PaymentGateway: 1,
      PaymentGatewayRules: [(v) => !!v || "Payment gateway is required"],
      PaymentGatewayOptions: [
        { value: "", text: "--Select--" },
        { value: 1, text: "Razorpay" },
      ],

      PaymentId: "",
      PaymentIdRules: [(v) => !!v || "Payment Id is required"],
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    validateForm() {
      console.log("validateForm called");
      this.$refs.form1.validate();
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
      this.PaymentGateway = 1;
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideAddRecordPrompt");
    },
    refreshPageData() {
      console.log("refreshPageData called");
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#1565C0",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        this.toast("error", "Kindly fill the required fields", true);
      }
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);

      if (validate1) {
        this.SubmitFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-rename/add-online-payment";
        var upload = {
          UserInterface: 1,
          PaymentGateway: this.PaymentGateway,
          PaymentId: this.PaymentId,
        };
        console.log("upload=" + JSON.stringify(upload));

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.sweetAlert("success", output, true);
              thisIns.resetForm();
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap");

.premium-dialog-wrapper {
  font-family: "Outfit", "Plus Jakarta Sans", sans-serif;
  animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.premium-checkout-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  border-radius: 24px !important;
  overflow: hidden;
  box-shadow: 0 24px 48px rgba(21, 101, 192, 0.18) !important;
  border: 1px solid rgba(255, 255, 255, 0.7) !important;
}

.checkout-banner {
  background: linear-gradient(135deg, #1565c0 0%, #1e88e5 50%, #42a5f5 100%);
  padding: 36px 24px;
  text-align: center;
  position: relative;
  overflow: hidden;
  color: white;
}

.floating-bg-shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  filter: blur(10px);
  pointer-events: none;
}

.shape-1 {
  width: 140px;
  height: 140px;
  top: -40px;
  left: -20px;
  animation: floatShape 8s ease-in-out infinite;
}

.shape-2 {
  width: 180px;
  height: 180px;
  bottom: -60px;
  right: -30px;
  animation: floatShape 10s ease-in-out infinite reverse;
}

.payment-avatar {
  background: rgba(255, 255, 255, 0.15) !important;
  border: 1px solid rgba(255, 255, 255, 0.25);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.payment-avatar:hover {
  transform: scale(1.08) rotate(5deg);
}

.pulse-icon {
  animation: pulseGlow 2s infinite ease-in-out;
}

.banner-title {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin-top: 8px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.banner-subtitle {
  font-size: 13px;
  font-weight: 400;
  opacity: 0.9;
  margin-bottom: 0;
  margin-top: 4px;
}

.card-content-area {
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.8) 0%,
    #ffffff 100%
  );
}

.input-label-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.premium-label {
  font-size: 13px;
  font-weight: 600;
  color: #37474f;
  margin-bottom: 0;
}

.required-star {
  color: #d32f2f;
  font-weight: bold;
}

.premium-input >>> .v-input__control > .v-input__slot {
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
  border: 1.5px solid rgba(21, 101, 192, 0.12) !important;
  background-color: rgba(21, 101, 192, 0.01) !important;
}

.premium-input >>> .v-input__control > .v-input__slot:hover {
  border-color: rgba(21, 101, 192, 0.4) !important;
}

.premium-input.v-input--is-focused >>> .v-input__control > .v-input__slot {
  border-color: #1565c0 !important;
  box-shadow: 0 0 0 3px rgba(21, 101, 192, 0.15) !important;
  background-color: white !important;
}

.security-badge {
  background: rgba(76, 175, 80, 0.06);
  border-top: 1px solid rgba(76, 175, 80, 0.1);
  border-bottom: 1px solid rgba(76, 175, 80, 0.1);
  color: #2e7d32;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.premium-btn {
  font-weight: 600 !important;
  letter-spacing: 0.3px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  text-transform: none !important;
}

.btn-close {
  color: #546e7a !important;
  border: 1.5px solid rgba(84, 110, 122, 0.25) !important;
}

.btn-close:hover {
  background-color: rgba(84, 110, 122, 0.05) !important;
  border-color: #546e7a !important;
}

.btn-save {
  background: linear-gradient(135deg, #1565c0 0%, #1e88e5 100%) !important;
  box-shadow: 0 6px 20px rgba(21, 101, 192, 0.3) !important;
  border: none !important;
}

.btn-save:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(21, 101, 192, 0.45) !important;
}

.btn-save:active {
  transform: translateY(1px);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes floatShape {
  0%,
  100% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-15px) scale(1.05);
  }
}

@keyframes pulseGlow {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.85;
  }
}
</style>
